import { format, parseISO } from 'date-fns'
import type { Locale } from './index'

const DAY_KEY = 'yyyy-MM-dd'

const parsed = (value: string | Date) => (value instanceof Date ? value : parseISO(value))

export const dayKey = (value: string | Date): string => format(parsed(value), DAY_KEY)

export const today = (): string => dayKey(new Date())

export const stampedAt = (value: string, locale: Locale) =>
  new Date(value).toLocaleString(locale, { dateStyle: 'medium', timeStyle: 'medium' })

export const dayOf = (value: string, locale: Locale) =>
  new Date(value).toLocaleDateString(locale, { dateStyle: 'medium' })

export const moneyOf = (value: string, locale: Locale, currency: string) =>
  new Intl.NumberFormat(locale, { style: 'currency', currency }).format(Number(value))
